import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import {
  MEDIA_QUERY_SMALL_SCREEN,
} from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

const PartnerAgentOwnerMarketingPageHeader = ({
  partner,
}) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <SrBox
      boxSizing='border-box'
      backgroundColor='#04121F'
      width='100%'
      minHeight={isSmallScreen ? '670px' : '645px'}
      padding={isSmallScreen ? '182px 20px 169px' : '160px 20px'}
    >
      <SrText
        color='white'
        weight='700'
        align='center'
        font='greycliff'
        size={isSmallScreen ? '50' : '64'}
        lineHeight={isSmallScreen ? '60px' : '77px'}
        display='block'
      >
        Let's Lease Your Property!
      </SrText>
      <SrBox marginTop={isSmallScreen ? '42px' : '64px'}>
        {partner.logoUrl && (
          <img
            src={partner.logoUrl}
            alt='partner logo'
            height='auto'
            width='auto'
            style={{
              margin: '0 auto',
              display: 'block',
              maxHeight: '300px',
              maxWidth: '100%',
            }}
          />
        )}
        <SrBox marginTop='32px'>
          <SrText
            size='24'
            color='white'
            weight='600'
            align='center'
            font='greycliff'
            lineHeight='24px'
            display='block'
          >
            {partner.displayName}
          </SrText>
        </SrBox>
        {partner.brokerName && (
          <SrBox marginTop='16px'>
            <SrText
              size='18'
              color='white'
              weight='400'
              align='center'
              font='greycliff'
              lineHeight='24px'
              display='block'
            >
              Brokerage {partner.brokerName}
            </SrText>
          </SrBox>
        )}
      </SrBox>
    </SrBox>
  );
};

PartnerAgentOwnerMarketingPageHeader.propTypes = {
  partner: PropTypes.object.isRequired,
};

PartnerAgentOwnerMarketingPageHeader.displayName = 'PartnerAgentOwnerMarketingPageHeader';

export default PartnerAgentOwnerMarketingPageHeader;
